export default {
      id: "appli_mobile-usage",
      viewBox: "0 0 74 72",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#appli_mobile-usage",
      toString: function () {
        return this.url;
      }
    }